import { AnyAction } from 'redux';
import { FETCH_FUN_FACT } from './actions';
import { FunFactState } from './types';

const initialState: FunFactState = {
    fact: '',
    timestamp: null,
};

const funFactReducer = (
    state = initialState,
    action: AnyAction,
): FunFactState => {
    const { type, payload } = action;

    switch (type) {
        case FETCH_FUN_FACT:
            return {
                ...state,
                fact: payload.fact,
                timestamp: payload.timestamp,
            };
        default:
            return state;
    }
};

export default funFactReducer;
